import { defineComponent } from 'vue'
import { ClientOnly, GfrButton, GfrScrollArea, IconsDesktop, IconsMobile } from '#components'
type BlocklyType = 'fe' | 'cl' | 'none'
export default defineComponent({
  name: 'MarkdownBlockly',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const blocklyRef = ref<HTMLElement>()
    const blockly = ref<any>()
    const route = useRoute()
    const blocklyType = ref<BlocklyType>()
    const blocklyTypes = computed(() => {
      return Object.keys(props.data) as BlocklyType[]
    })
    const blocklyTypeIndex = computed(() => {
      return blocklyTypes.value.findIndex((t) => t === blocklyType.value)
    })
    function toggleBlocklyType(type: BlocklyType) {
      blocklyType.value = type
    }
    async function initBlockly(type: BlocklyType) {
      const { $blockly } = useNuxtApp()
      const defaultBlocklyLang = import.meta.env.VITE_BLOCKLY_DEFAULT_LANG
      const lang = route.params.lang === 'en' && defaultBlocklyLang === 'en-in' ? 'en-in' : route.params.lang
      const blocklyData = props.data.cl
      blocklyRef.value &&
        blocklyData &&
        (blockly.value = await $blockly(blocklyRef.value, blocklyData, lang || defaultBlocklyLang, true))
    }
    watch(blocklyType, async () => {
      if (blocklyRef.value) {
        blockly.value && blockly.value.dispose()
        await initBlockly(blocklyType.value as BlocklyType)
      }
    })
    onMounted(async () => {
      await nextTick()
      try {
        toggleBlocklyType('cl')
      } catch (error) {
        console.error(error)
      }
    })
    onUnmounted(() => {
      if (blockly.value) {
        blockly.value.dispose()
      }
    })
    return () => (
      <ClientOnly>
        {props.data.cl && (
          <div class={'app-markdown-blockly-inner flex justify-between'}>
            <GfrScrollArea class="flex-1 pb-4 mr-4 inline-flex" direction="horizontal">
              <div ref={blocklyRef} class={'app-markdown-blockly'} />
            </GfrScrollArea>
          </div>
        )}
      </ClientOnly>
    )
  }
})
